import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function lengthValidator(min: number, max: number): ValidatorFn  {
  return (control: AbstractControl): LengthValidation | null => {
    const stringValue = String(control.value);
    const length = true;
    if (stringValue.length === 0) {
      return null;
    }
    if (stringValue.length >= min && stringValue.length <= max) {

      return null;
    }

    return {length};
};
}

export interface LengthValidation extends ValidationErrors {
  length: boolean;
}

